(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["header-menu"] && !Shopify.designMode) return;
  try {
    (() => {
    const ITEM = '.menu-list__list-item--mega';
    const PANEL = '.menu-list__submenu--mega';
    const LEAVE_DELAY = 250;
    const EDGE_TOLERANCE = 8;
    const leaveTimers = new WeakMap();
    let pointerX = 0;
    let pointerY = 0;

    const dismiss = panel => {
      clearTimeout(leaveTimers.get(panel));
      panel.dataset.dismissed = 'true';
      panel.parentElement?.querySelector('.menu-list__link')?.setAttribute('aria-expanded', 'false');
    };

    const reset = event => {
      const item = event.target.closest?.(ITEM);
      const panel = item?.querySelector(PANEL);
      if (!panel || panel.contains(event.target)) return;
      clearTimeout(leaveTimers.get(panel));
      delete panel.dataset.dismissed;
    };

    document.addEventListener('pointermove', event => {
      pointerX = event.clientX;
      pointerY = event.clientY;
    }, { passive: true });
    document.addEventListener('pointerover', reset);
    document.addEventListener('focusin', reset);

    document.addEventListener('pointerout', event => {
      const item = event.target.closest?.(ITEM);
      if (!item) return;
      const to = event.relatedTarget;
      if (to && item.contains(to)) return;
      const panel = item.querySelector(PANEL);
      if (!panel) return;
      clearTimeout(leaveTimers.get(panel));
      if (!to) return dismiss(panel);
      leaveTimers.set(panel, setTimeout(() => {
        const rect = panel.getBoundingClientRect();
        const insidePanel =
          pointerX >= rect.left - EDGE_TOLERANCE &&
          pointerX <= rect.right + EDGE_TOLERANCE &&
          pointerY >= rect.top - EDGE_TOLERANCE &&
          pointerY <= rect.bottom + EDGE_TOLERANCE;
        if (!insidePanel) dismiss(panel);
      }, LEAVE_DELAY));
    });

    document.addEventListener('click', event => {
      const button = event.target.closest?.('.close-menu');
      const panel = button?.closest(PANEL);
      if (panel) dismiss(panel);
    });

    document.addEventListener('keydown', event => {
      if (event.key !== 'Escape') return;
      const item = event.target.closest?.(ITEM);
      const panel = item?.querySelector(PANEL);
      if (!panel || panel.hasAttribute('data-dismissed')) return;
      const trigger = item.querySelector('.menu-list__link');
      if (trigger?.getAttribute('aria-expanded') !== 'true' && !panel.matches(':hover')) return;
      event.preventDefault();
      event.stopPropagation();
      trigger?.focus({ preventScroll: true });
      dismiss(panel);
    }, { capture: true });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["help-center-scripts"] && !Shopify.designMode) return;
  try {
    (function () {
  "use strict";

  var HC = {
    searchInput: null,
    searchSubmit: null,
    faqQuery: ""
  };

  function initFaqSearchResults() {
    var results = document.getElementById("searchResults");
    if (!results) return;
    document.querySelectorAll("template[data-faq-search-source]").forEach(function (source) {
      if (source.dataset.searchIndexed === "true") return;
      var cards = document.createDocumentFragment();
      source.content.querySelectorAll(".faq-item").forEach(function (item) {
        var question = item.querySelector(".faq-question");
        var title = item.querySelector(".faq-title");
        var answer = item.querySelector(".faq-answer-body");
        if (!question || !title || !answer) return;
        var target = question.getAttribute("aria-controls");
        if (!target) return;
        var answerText = answer.textContent.replace(/\s+/g, " ").trim();
        var card = document.createElement("a");
        card.className = "result-card";
        card.href = "/pages/help-center-faqs?product=" + encodeURIComponent(source.dataset.product) + "#" + encodeURIComponent(target);
        card.dataset.searchText = (source.dataset.productLabel + " " + (item.dataset.faqText || title.textContent + " " + answerText)).replace(/\s+/g, " ").toLowerCase();
        var type = document.createElement("div");
        type.className = "result-type";
        type.textContent = "FAQ · " + source.dataset.productLabel;
        var heading = document.createElement("h3");
        heading.textContent = title.textContent.replace(/\s+/g, " ").trim();
        var description = document.createElement("p");
        description.textContent = answerText.length > 220 ? answerText.slice(0, 217) + "…" : answerText;
        card.appendChild(type);
        card.appendChild(heading);
        card.appendChild(description);
        cards.appendChild(card);
      });
      results.appendChild(cards);
      source.dataset.searchIndexed = "true";
    });
  }

  function filterSearch(query) {
    var normalized = (query || "").toLowerCase();
    var count = 0;
    document.querySelectorAll(".result-card").forEach(function (card) {
      var match = !normalized || (card.dataset.searchText || "").indexOf(normalized) !== -1;
      card.style.display = match ? "" : "none";
      if (match) count += 1;
    });
    var title = document.getElementById("resultTitle");
    var countLabel = document.getElementById("resultCount");
    var empty = document.getElementById("emptyState");
    if (title) title.textContent = query ? "Results for \u201c" + query + "\u201d" : "All searchable resources";
    if (countLabel) countLabel.textContent = count + " result" + (count === 1 ? "" : "s");
    if (empty) empty.style.display = count ? "none" : "block";
  }

  function initSearchJump() {
    HC.searchInput = document.getElementById("siteSearch");
    HC.searchSubmit = document.getElementById("searchSubmit");
    if (!HC.searchInput || !HC.searchSubmit) return;

    var isSearchPage = !!document.getElementById("searchResults");

    function goToSearch() {
      var query = (HC.searchInput.value || "").trim();
      if (HC.searchInput.closest(".help-center-faqs")) {
        updateFaqSearch();
        return;
      }
      if (isSearchPage) {
        filterSearch(query);
        return;
      }
      window.location.href = "/pages/help-center-search-results" + (query ? "?q=" + encodeURIComponent(query) : "");
    }

    HC.searchSubmit.addEventListener("click", goToSearch);
    HC.searchInput.addEventListener("keydown", function (event) {
      if (event.key === "Enter" && !event.isComposing) {
        event.preventDefault();
        goToSearch();
      }
    });

    if (isSearchPage) {
      initFaqSearchResults();
      var params = new URLSearchParams(window.location.search);
      var query = params.get("q") || "";
      HC.searchInput.value = query;
      filterSearch(query);
    }
  }

  function initFaqToggle() {
    document.querySelectorAll(".faq-item .faq-question").forEach(function (button) {
      button.addEventListener("click", function () {
        var item = button.closest(".faq-item");
        var open = item.classList.toggle("open");
        button.setAttribute("aria-expanded", String(open));
      });
    });
  }

  function guideSearchInput(library) {
    return library.querySelector("[data-guide-search]") || Array.from(library.closest(".help-center").querySelectorAll("[data-guide-search]")).find(function (input) {
      return !input.closest("[data-guide-library], .faq-panel");
    });
  }

  function applyGuideFilters(library) {
    if (!library) return;
    var bar = library.querySelector("[data-filter-bar]");
    if (!bar) return;
    var active = bar.querySelector(".filter-button.active");
    var category = active ? active.dataset.filter : "all";
    var input = guideSearchInput(library);
    var query = input ? input.value.trim().toLowerCase() : "";
    var visible = 0;
    library.querySelectorAll(".filter-item").forEach(function (item) {
      var text = (item.dataset.searchText || item.textContent).toLowerCase();
      var show = (category === "all" || item.dataset.category === category) && (!query || text.indexOf(query) !== -1);
      item.hidden = !show;
      if (show) visible += 1;
    });
    bar.querySelectorAll(".filter-button").forEach(function (button) {
      button.setAttribute("aria-pressed", String(button === active));
    });
    var count = library.querySelector(".result-count");
    if (count) count.textContent = visible + " " + (library.dataset.guideUnit || "guides") + " available";
    var empty = library.querySelector("[data-guide-empty]");
    if (empty) empty.hidden = visible !== 0;
  }

  function initGuideFilter() {
    document.querySelectorAll("[data-filter-bar]").forEach(function (bar) {
      var library = bar.closest("[data-guide-library], .faq-panel") || bar.closest(".shell");
      bar.querySelectorAll(".filter-button").forEach(function (button) {
        button.addEventListener("click", function () {
          bar.querySelectorAll(".filter-button").forEach(function (other) {
            other.classList.toggle("active", other === button);
          });
          applyGuideFilters(library);
        });
      });
      applyGuideFilters(library);
    });
    document.querySelectorAll("[data-guide-search]").forEach(function (input) {
      input.addEventListener("input", function () {
        var library = input.closest("[data-guide-library], .faq-panel");
        if (library) applyGuideFilters(library);
        else input.closest(".help-center").querySelectorAll("[data-guide-library]").forEach(applyGuideFilters);
      });
    });
    document.querySelectorAll("[data-guide-clear]").forEach(function (button) {
      button.addEventListener("click", function () {
        var library = button.closest("[data-guide-library], .faq-panel");
        var input = guideSearchInput(library);
        if (input) input.value = "";
        library.querySelector('[data-filter="all"]').click();
        if (input) input.focus();
      });
    });
  }

  function applyFaqFilters(panel) {
    if (!panel) return;
    var bar = panel.querySelector("[data-faq-filter]");
    if (!bar) return;
    var activeButton = bar.querySelector(".filter-button.active");
    var category = activeButton ? activeButton.dataset.filter : "all";
    var items = panel.querySelectorAll(".faq-item");
    var visible = 0;
    items.forEach(function (item) {
      var matchesCategory = category === "all" || item.dataset.category === category;
      var matchesQuery = !HC.faqQuery || (item.dataset.faqText || "").indexOf(HC.faqQuery) !== -1;
      var show = matchesCategory && matchesQuery;
      item.style.display = show ? "" : "none";
      if (!show) {
        item.classList.remove("open");
        var question = item.querySelector(".faq-question");
        if (question) question.setAttribute("aria-expanded", "false");
      }
      if (show) visible += 1;
    });
    var countLabel = panel.querySelector(".result-count");
    var empty = panel.querySelector(".empty-state");
    if (countLabel) {
      countLabel.textContent = HC.faqQuery
        ? visible + " answer" + (visible === 1 ? "" : "s") + " for \u201c" + HC.faqQuery + "\u201d"
        : visible + " answer" + (visible === 1 ? "" : "s") + " available";
    }
    if (empty) empty.style.display = visible ? "none" : "block";
  }

  function updateFaqSearch() {
    if (!HC.searchInput) return;
    var root = HC.searchInput.closest(".help-center-faqs");
    if (!root) return;
    HC.faqQuery = (HC.searchInput.value || "").trim().toLowerCase();
    applyFaqFilters(root.querySelector(".faq-panel:not([hidden])"));
  }

  function initFaqFilter() {
    var bars = document.querySelectorAll("[data-faq-filter]");
    if (!bars.length) return;

    bars.forEach(function (bar) {
      bar.querySelectorAll(".filter-button").forEach(function (button) {
        button.addEventListener("click", function () {
          bar.querySelectorAll(".filter-button").forEach(function (b) {
            b.classList.toggle("active", b === button);
          });
          applyFaqFilters(bar.closest(".faq-panel"));
        });
      });
    });

    if (HC.searchInput && HC.searchInput.closest(".help-center-faqs")) {
      HC.searchInput.addEventListener("input", updateFaqSearch);
      updateFaqSearch();
    }
  }

  function initProductTabs() {
    document.querySelectorAll('.product-tabs[role="tablist"], .product-picker[role="tablist"]').forEach(function (list) {
      var tabs = Array.from(list.querySelectorAll("[data-faq-product]"));
      var root = list.closest(".help-center");
      function productFor(tab) {
        if (tab.dataset.faqProduct === "orders-support") return "orders-support";
        return tab.dataset.faqProduct.indexOf("note-one") !== -1 ? "note-one" : "note-plus";
      }
      function select(tab, updateUrl) {
        tabs.forEach(function (other) {
          var on = other === tab;
          other.classList.toggle("active", on);
          other.setAttribute("aria-selected", String(on));
          other.tabIndex = on ? 0 : -1;
          var panel = document.getElementById(other.getAttribute("aria-controls"));
          if (panel) panel.hidden = !on;
        });
        var panel = document.getElementById(tab.getAttribute("aria-controls"));
        if (HC.searchInput && panel && panel.dataset.searchPlaceholder) HC.searchInput.placeholder = panel.dataset.searchPlaceholder;
        applyFaqFilters(panel);
        applyGuideFilters(panel);
        var title = panel && panel.querySelector("h1");
        var breadcrumb = root.querySelector("[data-product-title]");
        if (title && breadcrumb) {
          breadcrumb.textContent = title.textContent;
          document.title = title.textContent + " | UMEVO Help Center";
        }
        if (updateUrl) {
          var url = new URL(window.location.href);
          url.searchParams.set("product", productFor(tab));
          url.hash = "";
          window.history.replaceState(null, "", url);
        }
      }
      function selectFromUrl() {
        var requested = new URLSearchParams(window.location.search).get("product");
        var hash = window.location.hash.slice(1);
        var target = document.getElementById(hash);
        var panel = target && target.closest(".faq-panel");
        var tab = tabs.find(function (item) {
          return (panel && item.getAttribute("aria-controls") === panel.id) || item.dataset.faqProduct === hash || productFor(item) === hash;
        }) || tabs.find(function (item) { return productFor(item) === requested; });
        select(tab || tabs.find(function (item) { return item.getAttribute("aria-selected") === "true"; }) || tabs[0], false);
        var faqItem = target && panel && target.closest(".faq-item");
        if (faqItem) {
          HC.faqQuery = "";
          if (HC.searchInput) HC.searchInput.value = "";
          panel.querySelectorAll("[data-faq-filter] .filter-button").forEach(function (button) {
            button.classList.toggle("active", button.dataset.filter === "all");
          });
          applyFaqFilters(panel);
          faqItem.classList.add("open");
          var question = faqItem.querySelector(".faq-question");
          if (question) question.setAttribute("aria-expanded", "true");
        }
        if (target && panel) requestAnimationFrame(function () { target.scrollIntoView({ block: "start" }); });
      }
      tabs.forEach(function (tab, index) {
        tab.addEventListener("click", function () { select(tab, true); });
        tab.addEventListener("keydown", function (event) {
          var next = index;
          if (event.key === "ArrowRight") next = (index + 1) % tabs.length;
          else if (event.key === "ArrowLeft") next = (index + tabs.length - 1) % tabs.length;
          else if (event.key === "Home") next = 0;
          else if (event.key === "End") next = tabs.length - 1;
          else return;
          event.preventDefault();
          tabs[next].focus();
          select(tabs[next], true);
        });
      });
      selectFromUrl();
      window.addEventListener("hashchange", selectFromUrl);
      window.addEventListener("popstate", selectFromUrl);
    });
  }

  function initSideNavSpy() {
    document.querySelectorAll(".side-nav").forEach(function (nav) {
      var items = Array.from(nav.querySelectorAll('a[href^="#"]')).map(function (link) {
        return { link: link, target: document.getElementById(decodeURIComponent(link.hash.slice(1))) };
      }).filter(function (item) { return item.target; });
      if (!items.length) return;
      var offset = parseFloat(getComputedStyle(items[0].target).scrollMarginTop) || 0;
      var frame;
      function inView(item) { return !item.target.closest("[hidden]"); }
      function mark() {
        var threshold = offset + 8;
        var current = items.filter(inView).filter(function (item) {
          return item.target.getBoundingClientRect().top <= threshold;
        }).pop();
        if (!current) current = items.find(inView);
        items.forEach(function (item) {
          var on = item === current;
          item.link.classList.toggle("active", on);
          if (on) item.link.setAttribute("aria-current", "location");
          else item.link.removeAttribute("aria-current");
        });
      }
      function schedule() {
        cancelAnimationFrame(frame);
        frame = requestAnimationFrame(mark);
      }
      window.addEventListener("scroll", schedule, { passive: true });
      window.addEventListener("resize", schedule);
      window.addEventListener("hashchange", schedule);
      document.addEventListener("click", function (event) {
        if (event.target.closest("[data-faq-product]")) schedule();
      });
      mark();
    });
  }

  function initPrintButtons() {
    document.querySelectorAll("[data-print]").forEach(function (button) {
      button.addEventListener("click", function () {
        window.print();
      });
    });
  }

  function initModal() {
    document.querySelectorAll("[data-open-modal]").forEach(function (button) {
      button.addEventListener("click", function () {
        var modal = document.getElementById(button.dataset.openModal);
        if (modal) {
          modal.classList.add("open");
          document.body.classList.add("modal-open");
        }
      });
    });

    function closeModal(modal) {
      if (modal) {
        modal.classList.remove("open");
        document.body.classList.remove("modal-open");
      }
    }

    document.querySelectorAll("[data-close-modal]").forEach(function (button) {
      button.addEventListener("click", function () {
        closeModal(button.closest(".modal"));
      });
    });

    document.querySelectorAll(".modal").forEach(function (modal) {
      modal.addEventListener("click", function (event) {
        if (event.target === modal) closeModal(modal);
      });
    });

    document.addEventListener("keydown", function (event) {
      if (event.key === "Escape") closeModal(document.querySelector(".modal.open"));
    });
  }

  function initImageFallback() {
    function markOffline(img) {
      var figure = img.closest(".guide-figure");
      if (!figure || figure.classList.contains("img-offline")) return;
      figure.classList.add("img-offline");
      var fallback = document.createElement("div");
      fallback.className = "img-fallback";
      fallback.innerHTML = "<strong>" + (img.alt || "Interface screenshot") + "</strong><br>This image failed to load. Please check the media URL.";
      figure.prepend(fallback);
    }

    document.querySelectorAll(".guide-figure .guide-img").forEach(function (img) {
      img.addEventListener("error", function () { markOffline(img); });
      if (img.complete && img.naturalWidth === 0) markOffline(img);
    });
  }

  function initDeviceGuide() {
    var root = document.querySelector(".help-center-device-guide-detail");
    if (!root) return;
    var params = new URLSearchParams(window.location.search);
    var requested = params.get("id") || window.location.hash.slice(1);
    var guides = Array.from(root.querySelectorAll("template[data-device-guide]"));
    var guide = guides.find(function (item) { return item.id === requested; });
    if (!guide && params.get("product") === "note-one") guide = guides[0];
    if (!guide) return;
    root.querySelector("[data-device-default]").hidden = true;
    root.querySelector("[data-device-reader]").hidden = false;
    root.querySelector("[data-device-content]").appendChild(guide.content.cloneNode(true));
    var title = guide.content.querySelector("h1").textContent;
    root.querySelector("[data-device-title]").textContent = title;
    root.querySelector("[data-device-back]").href = "/pages/help-center-device-guides?product=note-one";
    var nav = root.querySelector("[data-device-nav]");
    var heading = document.createElement("strong");
    heading.textContent = "All Note One device guides";
    nav.appendChild(heading);
    guides.forEach(function (item) {
      var link = document.createElement("a");
      link.href = "/pages/help-center-device-guide-detail?id=" + encodeURIComponent(item.id);
      link.textContent = item.content.querySelector("h1").textContent;
      if (item === guide) {
        link.classList.add("active");
        link.setAttribute("aria-current", "page");
      }
      nav.appendChild(link);
    });
    document.title = title + " | UMEVO Note One";
  }

  function init() {
    initDeviceGuide();
    initSearchJump();
    initFaqToggle();
    initGuideFilter();
    initFaqFilter();
    initProductTabs();
    initSideNavSpy();
    initPrintButtons();
    initModal();
    initImageFallback();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sale-dialog"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    var overlay = document.getElementById('saleDialogOverlay');
    var closeBtn = document.getElementById('saleDialogClose');
    var trigger = document.getElementById('saleDialogTrigger');
    var buyBtn = document.getElementById('saleDialogBuyBtn');

    var STORAGE_KEY = 'saleDialogClosedAt';
    var COOLDOWN = 3 * 24 * 60 * 60 * 1000; /* 3 days in ms */

    function shouldAutoShow() {
      var closedAt = localStorage.getItem(STORAGE_KEY);
      if (!closedAt) return true;
      return Date.now() - parseInt(closedAt, 10) >= COOLDOWN;
    }

    function openModal() {
      var scrollBarWidth = window.innerWidth - document.documentElement.clientWidth;
      overlay.classList.add('is-open');
      trigger.classList.remove('is-visible');
      document.body.style.overflow = 'hidden';
      document.body.style.paddingRight = scrollBarWidth + 'px';
    }

    function closeModal() {
      overlay.classList.remove('is-open');
      trigger.classList.add('is-visible');
      document.body.style.overflow = '';
      document.body.style.paddingRight = '0';
      localStorage.setItem(STORAGE_KEY, Date.now().toString());
    }

    /* Auto-show on page load (respects 3-day cooldown) */
    if (shouldAutoShow()) {
      openModal();
    } else {
      trigger.classList.add('is-visible');
    }

    /* Close: X button */
    closeBtn.addEventListener('click', closeModal);

    /* Close: click overlay background */
    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) closeModal();
    });

    /* Close: Escape key */
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && overlay.classList.contains('is-open')) closeModal();
    });

    /* Trigger: re-open */
    trigger.addEventListener('click', openModal);

    /* Buy Now: close the dialog (state saved to localStorage), then follow the link */
    buyBtn.addEventListener('click', function () {
      closeModal();
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["text"] && !Shopify.designMode) return;
  try {
    if (!window.toggleViewMore) {
    window.toggleViewMore = function(btn) {
      var wrapper = btn.closest('.view-more-wrapper');
      var content = wrapper.querySelector('.view-more-content');
      if (!content) return;

      var textNode = btn.childNodes[0];
      if (wrapper.classList.contains('expanded')) {
        var collapsedHeight = parseInt(wrapper.dataset.collapsedHeight, 10);
        content.style.maxHeight = content.scrollHeight + 'px';
        content.offsetHeight;
        content.style.maxHeight = collapsedHeight + 'px';
        wrapper.classList.remove('expanded');
        textNode.textContent = btn.dataset.textExpand;
      } else {
        var collapsedHeight = parseInt(wrapper.dataset.collapsedHeight, 10);
        content.style.maxHeight = collapsedHeight + 'px';
        content.offsetHeight;
        content.style.maxHeight = content.scrollHeight + 'px';
        wrapper.classList.add('expanded');
        textNode.textContent = btn.dataset.textCollapse;
        content.addEventListener('transitionend', function handler() {
          content.style.maxHeight = 'none';
          content.removeEventListener('transitionend', handler);
        });
      }
    };
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["use-cases-mega-menu"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('use-cases-menu')) {
    customElements.define(
      'use-cases-menu',
      class extends HTMLElement {
        connectedCallback() {
          this.controller?.abort();
          this.controller = new AbortController();
          const signal = this.controller.signal;
          const links = Array.from(this.querySelectorAll('[data-ucm-link]'));
          const preview = this.querySelector('[data-ucm-preview]');
          if (!links.length || !preview) return;

          const title = preview.querySelector('.ucm__title');
          const copy = preview.querySelector('.ucm__copy');
          const learn = preview.querySelector('.ucm__learn');
          const image = preview.querySelector('img');

          const select = (link) => {
            links.forEach((item) => item.classList.toggle('is-preview', item === link));
            preview.href = link.getAttribute('href');
            if (title) title.textContent = link.dataset.title || '';
            if (copy) copy.textContent = link.dataset.copy || '';
            if (learn) learn.textContent = `${link.dataset.cta} ↗`;
            if (image && link.dataset.image) {
              image.src = link.dataset.image;
              image.alt = link.dataset.alt || '';
            }
          };

          links.forEach((link) => {
            link.addEventListener('pointerenter', () => select(link), { signal });
            link.addEventListener('focus', () => select(link), { signal });
          });
          select(links[0]);
        }

        disconnectedCallback() {
          this.controller?.abort();
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
